import { render, staticRenderFns } from "./IngredientDisplay.vue?vue&type=template&id=4e57fd14&scoped=true"
import script from "./IngredientDisplay.vue?vue&type=script&lang=js"
export * from "./IngredientDisplay.vue?vue&type=script&lang=js"
import style0 from "./IngredientDisplay.vue?vue&type=style&index=0&id=4e57fd14&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e57fd14",
  null
  
)

export default component.exports